import { toast } from 'sonner';
import { auditoriaProveedoresApi } from '../../../lib/api';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { RotateCcw } from 'lucide-react';

const ESTADO = {
  corregido: { label: 'Corregida', variant: 'default' },
  ignorado: { label: 'Ignorada', variant: 'secondary' },
  resuelto: { label: 'Resuelta externamente', variant: 'outline' },
};
const fmt = (iso) => (iso ? new Date(iso).toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short' }) : '');

export const TablaHistorial = ({ items, onChange }) => {
  const reabrir = async (id) => {
    try {
      await auditoriaProveedoresApi.reabrir(id);
      toast.success('Discrepancia reabierta');
      onChange();
    } catch (e) {
      toast.error('No se pudo reabrir', { description: e.response?.data?.detail || e.message });
    }
  };
  if (!items.length) return <p className="text-sm text-muted-foreground py-8 text-center" data-testid="tabla-historial-vacio">Sin historial todavía.</p>;
  return (
    <div className="overflow-x-auto rounded-md border">
      <table className="w-full text-sm" data-testid="tabla-historial">
        <thead className="bg-muted/60 text-xs uppercase text-muted-foreground">
          <tr>
            <th className="p-2 text-left">Estado</th>
            <th className="p-2 text-left">RUT</th>
            <th className="p-2 text-left">Nombre / RUT en el ERP</th>
            <th className="p-2 text-left">Resultado</th>
            <th className="p-2 text-left">Quién / cuándo</th>
            <th className="p-2 text-left"></th>
          </tr>
        </thead>
        <tbody>
          {items.map((d) => {
            const e = ESTADO[d.estado] || { label: d.estado, variant: 'outline' };
            return (
              <tr key={d.id} className="border-b align-top" data-testid={`fila-historial-${d.id}`}>
                <td className="p-2"><Badge variant={e.variant}>{e.label}</Badge></td>
                <td className="p-2 font-mono text-xs">{d.rut_canonico || d.rut_erp}</td>
                <td className="p-2 text-sm">{d.clase === 'rut' ? `${d.nombre_erp} (${d.rut_erp})` : d.clase === 'pago_oc' ? `OC ${d.numero_oc} · ${d.nombre_erp}` : d.nombre_erp}</td>
                <td className="p-2 text-xs">
                  {d.estado === 'corregido' && (d.acciones || []).map((a, i) => <div key={i}>{a}</div>)}
                  {d.estado === 'ignorado' && <span className="italic">{d.ignorado_motivo || 'sin motivo'}</span>}
                  {d.estado === 'resuelto' && <span className="text-muted-foreground">Ya no difiere del documento</span>}
                </td>
                <td className="p-2 text-xs text-muted-foreground">
                  {d.corregido_por || d.ignorado_por || d.resuelto_por}<br />{fmt(d.corregido_en || d.ignorado_en || d.resuelto_en)}
                </td>
                <td className="p-2">
                  {d.estado === 'ignorado' && (
                    <Button size="sm" variant="ghost" onClick={() => reabrir(d.id)} title="Volver a pendientes" data-testid="btn-reabrir">
                      <RotateCcw className="w-4 h-4" />
                    </Button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
